/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — only the current roll is shown. Roll again to replace it. Nothing is stored or uploaded.`)
};

const es_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — solo se muestra la tirada actual. Tira de nuevo para reemplazarla. No se guarda ni se sube nada.`)
};

const de_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein — es wird nur der aktuelle Wurf angezeigt. Würfle erneut, um ihn zu ersetzen. Es wird nichts gespeichert oder hochgeladen.`)
};

const nl_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee — alleen de huidige worp wordt getoond. Gooi opnieuw om hem te vervangen. Er wordt niets opgeslagen of geüpload.`)
};

const fr_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non — seul le lancer actuel est affiché. Relancez pour le remplacer. Rien n'est stocké ni envoyé sur un serveur.`)
};

const it_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — viene mostrato solo il lancio attuale. Lancia di nuovo per sostituirlo. Nulla viene memorizzato o caricato online.`)
};

const pt_br2_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — só a rolagem atual é exibida. Role de novo para substituí-la. Nada é armazenado ou enviado.`)
};

const pt_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — só é mostrado o lançamento atual. Lance novamente para o substituir. Nada é guardado ou enviado.`)
};

const ja_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ — 現在のロール結果のみが表示されます。もう一度振ると上書きされます。何も保存・アップロードされません。`)
};

const zh_dice_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会——只显示当前的投掷结果。再次点击即可替换。不会存储或上传任何数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_faq_a4", locale)
	if (locale === "en") return en_dice_faq_a4(inputs)
	if (locale === "es") return es_dice_faq_a4(inputs)
	if (locale === "de") return de_dice_faq_a4(inputs)
	if (locale === "nl") return nl_dice_faq_a4(inputs)
	if (locale === "fr") return fr_dice_faq_a4(inputs)
	if (locale === "it") return it_dice_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_dice_faq_a4(inputs)
	if (locale === "pt") return pt_dice_faq_a4(inputs)
	if (locale === "ja") return ja_dice_faq_a4(inputs)
	return zh_dice_faq_a4(inputs)
};